// import "/assets/css/login.css";
import FrontendLayout from "../../layouts/FrontendLayout";
import Helmet from "../../components/Helmet";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

export default function Completed() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [previewData, setPreviewData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPreviewData = async () => {
      try {
        const response = await fetch(`${API_URL}/fetchPreviewData`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = await response.json();
        setPreviewData(data.data);
      } catch (err) {
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchPreviewData();
  }, [API_URL, navigate]);

  return (
    <>
      <Helmet title="Completed" />
      <FrontendLayout />
      <ToastContainer />

      {loading ? (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      ) : (
        <div className="main" style={{ minHeight: "calc(100vh - 120px)" }}>
          <section className="container-fluid py-5" style={{ width: "95%" }}>
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-5">
                {/* CARD */}
                <div className="card shadow-lg border-0 text-center p-4">
                  {/* Logo */}
                  <div className="mb-5">
                    <img
                      src="/img/logo.png"
                      alt="SOL Logo"
                      style={{ height: "200px", objectFit: "contain" }}
                    />
                  </div>
                  <h4 className="fw-bold text-success mb-3">
                    ✅ Your Form Has Been Successfully Completed
                  </h4>
                  <p className="text-muted mb-5">
                    Financial Support Scheme (FSS) 2026–27
                  </p>
                  {previewData.STAFF_REMARKS && (
                    <div
                      className={`mb-3 fw-bold ${
                        previewData.STATUS === "APPROVED"
                          ? "text-success"
                          : previewData.STATUS === "DISCREPANCY"
                            ? "text-warning"
                            : previewData.STATUS === "REJECTED"
                              ? "text-danger"
                              : ""
                      }`}
                    >
                      <b>{previewData.STAFF_REMARKS}</b>
                    </div>
                  )}

                  <button
                    className="btn btn-primary px-5 py-2"
                    onClick={() => navigate("/fullPreview")}
                  >
                    👁️ Preview Application
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
}
